(function () {
  class Jq23pHoverSlider extends HTMLElement {
    connectedCallback() {
      if (this.inited) return;
      this.inited = true;
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
      this.inited = false;
    }

    init() {
      this.cards = Array.from(this.querySelectorAll("[data-hs-card]"));
      this.slides = Array.from(this.querySelectorAll("[data-hs-slide]"));
      this.track = this.querySelector("[data-hs-track]");
      this.btn_prev = this.querySelector("[data-hs-prev]");
      this.btn_next = this.querySelector("[data-hs-next]");
      this.reduce_motion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.slide_index = this.slides.findIndex((slide) => slide.classList.contains("is-active"));
      if (this.slide_index < 0) this.slide_index = 0;
      this.mq = window.matchMedia("(max-width: 767px)");
      this.scroll_raf = 0;

      this.on_click = (event) => {
        const card = event.target.closest("[data-hs-card]");
        if (card && this.contains(card)) {
          const index = Number(card.getAttribute("data-hs-card"));
          this.activate_card(index);
          return;
        }

        if (event.target.closest("[data-hs-prev]")) {
          event.preventDefault();
          this.step_slide(-1);
          return;
        }

        if (event.target.closest("[data-hs-next]")) {
          event.preventDefault();
          this.step_slide(1);
        }
      };

      this.on_keydown = (event) => {
        const card = event.target.closest("[data-hs-card]");
        if (card && this.contains(card) && (event.key === "Enter" || event.key === " ")) {
          event.preventDefault();
          this.activate_card(Number(card.getAttribute("data-hs-card")));
        }
      };

      this.on_scroll = () => {
        if (this.scroll_raf) return;
        this.scroll_raf = requestAnimationFrame(() => {
          this.scroll_raf = 0;
          this.sync_from_scroll();
        });
      };

      this.on_mq = () => {
        this.go_slide(this.slide_index, false);
      };

      this.on_card_enter = (event) => {
        if (this.mq.matches) return;
        const card = event.currentTarget;
        this.activate_card(Number(card.getAttribute("data-hs-card")));
      };

      this.addEventListener("click", this.on_click);
      this.addEventListener("keydown", this.on_keydown);
      this.cards.forEach((card) => {
        card.addEventListener("mouseenter", this.on_card_enter);
      });
      if (this.track) {
        this.track.addEventListener("scroll", this.on_scroll, { passive: true });
      }
      if (this.mq.addEventListener) {
        this.mq.addEventListener("change", this.on_mq);
      } else if (this.mq.addListener) {
        this.mq.addListener(this.on_mq);
      }

      this.go_slide(this.slide_index, false);
    }

    activate_card(index) {
      if (!Number.isFinite(index) || index < 0 || index >= this.cards.length) return;

      this.cards.forEach((card, i) => {
        const is_active = i === index;
        card.classList.toggle("is-active", is_active);
        card.setAttribute("aria-pressed", is_active ? "true" : "false");
      });
    }

    step_slide(delta) {
      if (this.slides.length === 0) return;
      const next = (this.slide_index + delta + this.slides.length) % this.slides.length;
      this.go_slide(next, true);
    }

    go_slide(index, animate) {
      if (!Number.isFinite(index) || index < 0 || index >= this.slides.length) return;
      this.slide_index = index;
      const is_mobile = this.mq.matches;

      this.slides.forEach((slide, i) => {
        const is_active = i === index;
        slide.classList.toggle("is-active", is_active);
        slide.setAttribute("aria-hidden", is_mobile ? "false" : is_active ? "false" : "true");
        this.sync_videos(slide, is_active);
      });

      if (is_mobile && this.track) {
        const target = this.slides[index];
        if (!target) return;
        const pad_left = parseFloat(window.getComputedStyle(this.track).paddingLeft) || 0;
        this.track.scrollTo({
          left: Math.max(0, target.offsetLeft - pad_left),
          behavior: animate && !this.reduce_motion ? "smooth" : "auto"
        });
      }
    }

    sync_from_scroll() {
      if (!this.mq.matches || !this.track || this.slides.length === 0) return;
      const left = this.track.scrollLeft;
      let closest = 0;
      let min_delta = Infinity;
      this.slides.forEach((slide, i) => {
        const delta = Math.abs(slide.offsetLeft - left);
        if (delta < min_delta) {
          min_delta = delta;
          closest = i;
        }
      });
      if (closest !== this.slide_index) this.go_slide(closest, false);
    }

    sync_videos(panel, is_active) {
      const videos = panel.querySelectorAll("video");
      videos.forEach((video) => {
        if (is_active) {
          if (!this.reduce_motion && video.paused) {
            const play_promise = video.play();
            if (play_promise && typeof play_promise.catch === "function") {
              play_promise.catch(function () {});
            }
          }
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    destroy() {
      if (this.on_click) {
        this.removeEventListener("click", this.on_click);
        this.on_click = null;
      }
      if (this.on_keydown) {
        this.removeEventListener("keydown", this.on_keydown);
        this.on_keydown = null;
      }
      if (this.on_card_enter) {
        this.cards.forEach((card) => {
          card.removeEventListener("mouseenter", this.on_card_enter);
        });
        this.on_card_enter = null;
      }
      if (this.track && this.on_scroll) {
        this.track.removeEventListener("scroll", this.on_scroll);
      }
      if (this.mq && this.on_mq) {
        if (this.mq.removeEventListener) {
          this.mq.removeEventListener("change", this.on_mq);
        } else if (this.mq.removeListener) {
          this.mq.removeListener(this.on_mq);
        }
      }
      if (this.scroll_raf) {
        cancelAnimationFrame(this.scroll_raf);
        this.scroll_raf = 0;
      }
    }
  }

  function mount_jq23p_hover_slider(root) {
    if (!root) return;
    const panels = root.matches("jq23p-hover-slider")
      ? [root]
      : Array.from(root.querySelectorAll("jq23p-hover-slider"));

    panels.forEach((panel) => {
      if (panel.inited) {
        panel.disconnectedCallback();
        panel.connectedCallback();
      }
    });
  }

  if (!customElements.get("jq23p-hover-slider")) {
    customElements.define("jq23p-hover-slider", Jq23pHoverSlider);
  }

  document.addEventListener("shopify:section:load", (event) => {
    mount_jq23p_hover_slider(event.target);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const panel = event.target.closest("jq23p-hover-slider");
    if (!panel) return;

    const card = event.target.closest("[data-hs-card]");
    if (card && typeof panel.activate_card === "function") {
      panel.activate_card(Number(card.getAttribute("data-hs-card")));
      return;
    }

    const slide = event.target.closest("[data-hs-slide]");
    if (slide && typeof panel.go_slide === "function") {
      panel.go_slide(Number(slide.getAttribute("data-hs-slide")), false);
    }
  });
})();
